<template>
  <div class="layout" style="height: 100%">
    <div class="app-flex">
      <left-menu />
      <div class="appMain">
        <head-menu></head-menu>
        <div class="app-content">
          <div class="app-content-view">
            <router-view />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import leftMenu from './LeftMenu.vue'
import HeadMenu from "@/layout/HeadMenu.vue";
export default {
  components: {
    HeadMenu,
    leftMenu
  }
}
</script>
<style lang="scss" scoped>
.app-flex {
  display: flex;
  height: 100%;
}

.appMain {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  // align-items: center;
  background-color: #F5F6F9;
  box-sizing: border-box;
  width: 0;
  .app-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 0;
    flex:1;
    background-color: #fff;
    border-radius: 20px;
    margin:25px 25px 25px 10px;
    padding:25px 40px;
    .app-content-view{
      width: 100%;
      height: 100%;
      overflow-y: auto;
    }
  }
}
</style>
